module.exports = __webpack_public_path__ + "img/clientes_active.84b755ab.svg";